import { render, staticRenderFns } from "./EducationalStageTable.vue?vue&type=template&id=433600cd&"
import script from "./EducationalStageTable.vue?vue&type=script&lang=js&"
export * from "./EducationalStageTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports